import React, { useState } from 'react';
import { CQMasterDataStore } from '../../../../store/cq-master-data.store';
import { observer } from 'mobx-react';
import { IFieldData } from '../../component-level-fields/component-field';

interface IProps { 
    selectedTemplateName: string;
    fieldInfo: IFieldData;
}

const GridCustomTitle = (props: IProps) => {
    const [customTitle, setCustomTitle] =  useState(CQMasterDataStore.OutputConfig.getStoreKeyData(props.selectedTemplateName, 'customTitle'));
    
    React.useEffect(() => {
        CQMasterDataStore.OutputConfig.updateTemplatePropertyValue(props.selectedTemplateName, 'customTitle', customTitle.trim());
        
    }, [customTitle]);

    return (
        <div className="slds-col">
            <div className="slds-form-element">
                <label className="slds-form-element__label">{props.fieldInfo.name}</label>
                <div className="slds-form-element__control">
                    <input type="text" placeholder="Enter The Custom Title" className="slds-input"
                        onChange={(e: any) => setCustomTitle(e.target.value)} value={customTitle} />
                </div>
            </div>
        </div>
    );
}

export const GridComponentCustomTitle = observer(GridCustomTitle);